// import React, { useState } from "react";
// import axios from "axios";
// const { config } = require('../src/api/api.js');


// const SmartBoxPayment = () => {
//   const base_url = config.baseURL;
//   const [loading, setLoading] = useState(false);
//   const [merchantReference, setmerchantReference] = useState('');
//   // const merchantReference = `ORDER${Date.now()}`;

//   useState(() => {
//     // Load SmartBox script
//     const script = document.createElement("script");
//     script.src = config.amwalpayURL;
//     script.async = true;
//     document.body.appendChild(script);

//     return () => {
//       document.body.removeChild(script);
//     };
//   }, []);

//   const handlePayment = async () => {
//     setLoading(true);
//      const merchantReference = `ORDER${Date.now()}`;

//     try {
//       const res = await axios.post(base_url + "/payment-init", {
//         amount: 1.000,
//         // merchantReference: ORDER${Date.now()},
//         merchantReference : merchantReference
//       });

//       const { secureHash, trxParams } = res.data;

//       window.SmartBox.Checkout.configure = {

//         MID: trxParams.MerchantId,
//         TID: trxParams.TerminalId,
//         CurrencyId: trxParams.CurrencyId,
//         AmountTrxn: trxParams.Amount,
//         MerchantReference: trxParams.MerchantReference,
//         LanguageId: "en",
//         PaymentViewType: 1, // 1=Popup, 2=Fullscreen
//         TrxDateTime: trxParams.TrxDateTime,
//         SessionToken: trxParams.SessionToken,
//         SecureHash: secureHash,
//         completeCallback: async (data) => {
//           debugger
//           console.log("✅ Payment success:", data.data);
//           const verifyRes = await axios.post(base_url + "/payment-verify", data.data);
//           if(verifyRes.data.valid === true){
//             window.location.href = verifyRes.data.data
//           // window.location.href = `${config.redirectURL}/payment-success?order_id=${merchantReference}`;
//           }

            

          
//           console.log("Verification:", verifyRes.data);
//         },
//         errorCallback: (error) => {
//           debugger
//           window.location.href = `${config.redirectURL}/order-failed`;
//           console.error("❌ Payment error:", error);
//         },
//         cancelCallback: () => {
//           debugger
//           console.log("⚠️ Payment cancelled:", );
//         },
//       };
// // debugger
//       window.SmartBox.Checkout.showSmartBox();
//     } catch (err) {
//       console.error("Error initializing payment:", err);
//     }

//     setLoading(false);
//   };

//   return (
//     <div className="min-h-screen bg-gradient-to-r from-blue-50 to-indigo-50 flex items-center justify-center p-6">
//       <div className="max-w-md w-full bg-white rounded-2xl shadow-xl p-8 animate-fade-in">
//         {/* Header */}
//         <div className="text-center mb-6">
//           <h1 className="text-2xl font-bold text-gray-800 mb-2">
//             Complete Your Payment
//           </h1>
//           <p className="text-gray-500">
//             Secure and fast checkout powered by SmartBox
//           </p>
//         </div>

//         {/* Payment Info Card */}
//         <div className="bg-gradient-to-r from-blue-100 to-indigo-100 rounded-xl p-4 mb-6 shadow-inner">
//           {/* <p className="text-gray-700 font-medium">Order ID: <span className="font-bold">{merchantReference}</span></p> */}
//           <p className="text-gray-700 font-medium">Amount: <span className="font-bold">1.000 OMR</span></p>
//         </div>

//         {/* Payment Button */}
//         <div className="text-center">
//           <button
//             onClick={handlePayment}
//             disabled={loading}
//             className={`relative inline-flex items-center justify-center px-8 py-3 font-semibold text-white rounded-xl shadow-lg transition-all duration-300 transform
//               bg-gradient-to-r from-blue-600 to-indigo-600
//               hover:from-indigo-600 hover:to-blue-600
//               hover:scale-105
//               focus:outline-none focus:ring-4 focus:ring-indigo-300
//               ${loading ? "cursor-not-allowed opacity-70 animate-pulse" : "cursor-pointer"}
//             `}
//           >
//             {loading ? (
//               <svg
//                 className="w-5 h-5 mr-2 text-white animate-spin"
//                 xmlns="http://www.w3.org/2000/svg"
//                 fill="none"
//                 viewBox="0 0 24 24"
//               >
//                 <circle
//                   className="opacity-25"
//                   cx="12"
//                   cy="12"
//                   r="10"
//                   stroke="currentColor"
//                   strokeWidth="4"
//                 ></circle>
//                 <path
//                   className="opacity-75"
//                   fill="currentColor"
//                   d="M4 12a8 8 0 018-8v4l3-3-3-3v4a8 8 0 100 16v-4l-3 3 3 3v-4a8 8 0 01-8-8z"
//                 ></path>
//               </svg>
//             ) : null}
//             {loading ? "Processing..." : "Pay with SmartBox"}
//           </button>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default SmartBoxPayment;

import React, { useEffect, useState } from "react";
import axios from "axios";
import { config } from "../src/api/api.js";

const SmartBoxPayment = () => {
  const base_url = config.baseURL;
  const [loading, setLoading] = useState(false);

  // Load SmartBox.js dynamically
  useEffect(() => {
    const script = document.createElement("script");
    script.src = config.amwalpayURL; // Example: https://test.amwalpg.com:7443/js/SmartBox.js?v=1.1
    script.async = true;

    script.onload = () => {
      console.log("SmartBox.js Loaded");
    };

    script.onerror = () => {
      console.error("Failed to load SmartBox.js");
      alert("SmartBox payment script failed to load. Please check network blocks.");
    };

    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, []);

  const handlePayment = async () => {
    setLoading(true);
    const merchantReference = `ORDER${Date.now()}`;

    try {
      // 1. INIT PAYMENT (Backend)
      const res = await axios.post(base_url + "/payment-init", {
        // amount: 1.000,
        amount: 0.1, // For testing purpose
        merchantReference,
      });

      const { secureHash, trxParams } = res.data;

      if (!window.SmartBox || !window.SmartBox.Checkout) {
        alert("SmartBox JS not loaded properly");
        setLoading(false);
        return;
      }

      // 2. CONFIGURE SMARTBOX CHECKOUT
      window.SmartBox.Checkout.configure = {
        MID: trxParams.MerchantId,
        TID: trxParams.TerminalId,
        CurrencyId: trxParams.CurrencyId,
        AmountTrxn: trxParams.Amount,
        MerchantReference: trxParams.MerchantReference,
        LanguageId: "en",
        PaymentViewType: 1,
        TrxDateTime: trxParams.TrxDateTime,
        SessionToken: trxParams.SessionToken,
        SecureHash: secureHash,

        // 3. PAYMENT SUCCESS
        completeCallback: async (response) => {
          console.log("AMWAL Payment Success:", response);
debugger
          try {
            // 4. VERIFY PAYMENT (Backend)
            const verifyRes = await axios.post(
              base_url + "/payment-verify",
              response.data
            );

            if (verifyRes.data?.valid === true) {
              window.location.href = verifyRes.data.data; // your redirect URL
            } else {
              window.location.href = `${config.redirectURL}/order-failed`;
            }
          } catch (err) {
            console.error("Verification error:", err);
            window.location.href = `${config.redirectURL}/order-failed`;
          }
        },

        // 5. PAYMENT ERROR
        errorCallback: (error) => {
          console.error("AMWAL Error:", error);
          // window.location.href = `${config.redirectURL}/order-failed`;
        },

        // 6. USER CANCELS PAYMENT
        cancelCallback: () => {
          console.log("Payment Cancelled by User");
          window.location.href = `${config.redirectURL}/order-cancelled`;
        },
      };

      // 7. SHOW SMARTBOX POPUP
      window.SmartBox.Checkout.showSmartBox();
    } catch (err) {
      console.error("Init Error:", err);
      alert("Payment initialization failed.");
    }

    setLoading(false);
  };

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center p-6">
      <div className="max-w-md w-full bg-white rounded-2xl shadow-xl p-8">
        <h1 className="text-2xl font-bold text-center mb-3">Pay with SmartBox</h1>
        <p className="text-center text-gray-500 mb-6">
          Secure checkout powered by AMWAL
        </p>

        <div className="bg-indigo-100 p-4 rounded-xl mb-6">
          <p className="text-gray-700 font-medium">
            Amount: <span className="font-bold">1.000 OMR</span>
          </p>
        </div>

        <div className="text-center">
          <button
            onClick={handlePayment}
            disabled={loading}
            className={`px-8 py-3 text-white rounded-xl shadow-lg
              bg-gradient-to-r from-blue-600 to-indigo-600
              hover:scale-105 transition-all ${loading && "opacity-60 cursor-not-allowed"
              }`}
          >
            {loading ? "Processing..." : "Pay Now"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default SmartBoxPayment;
